const options: any = {
  chart: {
    id: "vuechart-example",
    toolbar: { tools: { download: false } },
  },
  grid: {
    strokeDashArray: 3,
  },
  colors: ['#2bbd85', '#5d1acf'],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded",
      labels: {
        show: false,
      }
    }
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"]
  },
  xaxis: {
    categories: [
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct"
    ]
  },
  fill: {
    opacity: 1
  }
};
const series: any = [
  {
    name: "TEAM A",
    data: [30, 40, 45, 50, 49, 60, 70, 91]
  },
  {
    name: "TEAM B",
    data: [15, 20, 35, 40, 40, 30, 50, 80]
  }
];
const type = 'bar';

const thinBar = { type, options, series };

export default thinBar; 
